import { render } from "./MainBanner.vue?vue&type=template&id=7847903b&scoped=true&ts=true"
import script from "./MainBanner.vue?vue&type=script&lang=ts"
export * from "./MainBanner.vue?vue&type=script&lang=ts"

import "./MainBanner.vue?vue&type=style&index=0&id=7847903b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7847903b"]])

export default __exports__